export const minWidth = 750;
export const maxWidth = 1200;
export const minScale = 16;
export const maxScale = 17;
